import { ClipboardList, Droplets, Activity, PackageSearch } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { SupportCTA } from "@/components/home/SupportCTA";
import { Reveal, RevealGroup, RevealItem } from "@/components/site/Reveal";
import { useLang } from "@/context/LanguageContext";
import { useSeo } from "@/hooks/useSeo";
import { IMG } from "@/data/images";

const ICONS = [ClipboardList, Droplets, Activity, PackageSearch];

export default function Support() {
  const { t, isRtl } = useLang();
  useSeo({
    title: isRtl ? "الدعم الفني | شركة الأبرد" : "Technical Support | Al-Abrad",
    description: t.supportPage.sub,
  });

  return (
    <>
      <PageHero title={t.supportPage.title} subtitle={t.supportPage.sub} image={IMG.vetExamining} crumb={t.nav.support} />

      <section className="bg-cream py-24 lg:py-32">
        <div className="container-x">
          <Reveal>
            <h2 className="mb-14 max-w-2xl font-display text-4xl font-extrabold leading-tight tracking-tight text-forest sm:text-5xl">
              {t.supportPage.servicesTitle}
            </h2>
          </Reveal>
          <RevealGroup className="grid gap-6 sm:grid-cols-2">
            {t.supportPage.services.map((s, i) => {
              const Icon = ICONS[i];
              return (
                <RevealItem
                  key={i}
                  data-testid={`service-${i}`}
                  className="group flex gap-6 rounded-2xl border border-line bg-white p-8 transition-all duration-500 hover:-translate-y-1 hover:border-forest/30"
                >
                  <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-sage text-forest transition-colors duration-500 group-hover:bg-forest group-hover:text-gold-light">
                    <Icon className="h-7 w-7" strokeWidth={1.6} />
                  </span>
                  <div>
                    <h3 className="font-display text-xl font-bold text-forest">{s.t}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-stone">{s.d}</p>
                  </div>
                </RevealItem>
              );
            })}
          </RevealGroup>
        </div>
      </section>

      <SupportCTA />
    </>
  );
}
